import React from 'react';
import { toast } from 'react-toastify';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import client from '../../../utils/apolloClient';

const updatePlaceTimestampMutation = gql`
  mutation updatePlaceTimestampMutation(
    $deviceId: String!
    $email: String!
    $id: String!
  ) {
    update_place_timestamp(
      input: { device_id: $deviceId, email: $email, id: $id }
    ) {
      device_id
      email
      id
      success
    }
  }
`;

const RefreshButton = ({ requestObject }) => {
  const [updatePlaceTimestamp, { loading: isLoading }] = useMutation(
    updatePlaceTimestampMutation,
    {
      client: client.clientPrivate,
      onCompleted: ({ update_place_timestamp }) => {
        if (update_place_timestamp.success) {
          toast.success('Successfully sent restart signal to firestore!');
        } else {
          toast.error('Error sending restart signal to firestore!');
        }
      },
    },
  );

  const onClickRefreshButton = async () => {
    try {
      await updatePlaceTimestamp({
        variables: {
          ...requestObject,
        },
      });
    } catch {
      toast.error('Error sending restart signal to firestore!');
    }
  };

  return (
    <div>
      <a
        className={`button is-success is-rounded ${isLoading && 'is-loading'} `}
        onClick={async () => onClickRefreshButton()}
        disabled={isLoading}
      >
        <p className="has-text-weight-semibold">Restart App</p>
      </a>
    </div>
  );
};

export default RefreshButton;
